import FormJaivana from 'dashboard_jaivana_v1';
/**
 *
 * @author Santiago_Hernandez
 * @updateBy Sebastian Rios Echverri
 * Versiones corregidas: 1.01.0054
 */
/**
 * Custom con funciones adicionales al formulario de produccion - ajuste_agregacion
 **/
class CustomAjustesAgregacion extends FormJaivana.form {

    /**
     * Se instancian las funciones e inician variables globales que son requeridos en la clase
     * @constructor
     * @param {string} props Propiedades que se pasan por parametros en los componentes
     */
    constructor(props) {
        super(props);
        this.initForm                           = this.initForm.bind(this);
        this.successDatosFicha                  = this.successDatosFicha.bind(this);
        this.successTbAgregacion                = this.successTbAgregacion.bind(this);
        this.gridOptionsTbAgregacion            = Object.assign({}, this.gridOptions);
        this.setButtonCantidadAgregada          = this.setButtonCantidadAgregada.bind(this);
        this.cantidadAgregadaChange             = this.cantidadAgregadaChange.bind(this);
        this.successCantidadAgregada            = this.successCantidadAgregada.bind(this);
        this.uploadTbAgregacion                 = this.uploadTbAgregacion.bind(this);
        this.grabarTodo                         = this.grabarTodo.bind(this);
        this.verFormula                         = this.verFormula.bind(this);
        this.successVerFormula                  = this.successVerFormula.bind(this);
        this.gridOptionsVerFormula              = Object.assign({}, this.gridOptions);
    }
    /**
     * Función principal, es la primera en ejecutarse al iniciar el formulario.
     */
    initForm() {
        console.log('CustomAjustesAgregacion @version: 1.01.0054 @author: Juan David Nieto; @updateBy: Sebastian Rios Echverri');
        this.getField('btnTerminarAgregacion').setClick(this.grabarTodo);

        let datos = {
            datos:{
                value: this.props.data.id_ficha, 
            }
        }

        this.generalFormatPmv = { tipo_servicio: 'prod-fichas', operacion: 'iddatos', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successDatosFicha,
            error: this.error_,
            showMessage :false,
            general: this.generalFormatPmv
        });

        // prod-agregacionajustes

        this.generalFormatPmv = { tipo_servicio: 'prod-agregacionajustes', operacion: 'fichaid', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successTbAgregacion,
            error: this.error_,
            showMessage :false,
            general: this.generalFormatPmv
        });

        /*this.generalFormat.nombre_accion = '271-Retorna_datos_ficha'; 
        this.service.send(
            {
                endpoint:this.constant.formConfiguration(),
                method:'GET',
                body:body,
                success:this.successDatosFicha,
                error:this.error_,
                general: this.generalFormat
            });
        this.generalFormat.nombre_accion = '271-Retorna_los_items_ajustes_leidos_por_produccion_fichas_id'; 
        this.service.send(
            {
                endpoint:this.constant.formConfiguration(),
                method:'GET',
                body:body,
                success:this.successTbAgregacion,
                error:this.error_,
                general: this.generalFormat
            });*/

        this.getField('btn_verformula').setClick(this.verFormula);
    }

    verFormula(){
        let datos = {
            datos:{
                value: this.props.data.id_ficha,
            }
        }
        this.generalFormatPmv = { tipo_servicio: 'prod-fichas', operacion: 'verformula', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successVerFormula,
            error: this.error_,
            showMessage: false,
            general: this.generalFormatPmv
        });
    }

    successVerFormula(data){
        if (data.estado_p === 200 && data.data.length >= 1) {
            this.getField('modal_verformula').handleClickOpen();
            this.getField('tb_verformula').toggle(true);
            this.gridOptionsVerFormula['rowData'] = data.model;
            let configCell = new Map();
            configCell.set('nombre_articulo',{headerName: 'Nombre Artículo'});
            configCell.set('version',{headerName: 'Versión'});
            configCell.set('produccion_formulas_versiones',{headerName: 'Producción Fórmulas Versiones'});
            configCell.set('estado_descripcion',{headerName: 'Estado Descripción'});
            this.getField('tb_verformula').initData(this.gridOptionsVerFormula, configCell);
        }else if (data.estado_p === 404){
            this.alertGeneral.toggle(true,'No hay datos',"error");
            this.getField('tb_verformula').toggle(true);
            this.getField('modal_verformula').handleClose();
        }else{
            this.alertGeneral.toggle(true,'Error al consumir el servicio.',"error");
            this.getField('tb_verformula').toggle(true);
            this.getField('modal_verformula').handleClose();
        }
    }
    
    /**
     * Función que recibe los datos del servidor para ser mostrados en la lista,
     * @param {string} data 
     */
    successDatosFicha(data){
        if (data.estado_p === 200 && data.model !== undefined && data.model.length > 0){
            this.getField('listaAgregacion').setVisible(true);
            this.getField('listaAgregacion').setItemsFichas(data.model);
        }else{
            this.getField('listaAgregacion').setVisible(false);
        }
    }

    successTbAgregacion(data){
        this.getField('btnTerminarAgregacion').setDisabled(false);
        if (data.estado_p === 200 && data.model !== undefined && data.model.length > 0) 
        {
            this.gridOptionsTbAgregacion['rowData']=[];
            this.getField('tablaAgregacion').initData(this.gridOptionsTbAgregacion);
            let configCell = new Map();
            configCell.set('cantidad_agregada',{cellRenderer:this.setButtonCantidadAgregada,cellStyle: {backgroundColor: "rgb(238,238,238)",textAlign:"right",borderRadius:"5px",color:'rgb(0, 86, 201)'}, onCellValueChanged:this.cantidadAgregadaChange,width:100, editable: true, field: 'cantidad_agregada' });   
            this.getField('tablaAgregacion').toggle(true);
            this.gridOptionsTbAgregacion['rowData'] = data.model;
            this.gridOptionsTbAgregacion.paginationPageSize = 100;
            this.getField('tablaAgregacion').initData(this.gridOptionsTbAgregacion,configCell);
        }else{ 
          this.getField('tablaAgregacion').toggle(false);
        }
        this.getField('cantidad_agregada').setValue(' ');
    }

    setButtonCantidadAgregada(props){
        let valor_actual = props.data.cantidad_agregada;
        let div = document.createElement("div");
        let label = document.createElement("label");
        if(valor_actual !== null && valor_actual !== '' && valor_actual !== undefined && valor_actual > 0 ){
            label.textContent = valor_actual;
            return "".formatoPrecio(props.data.cantidad_agregada); // se pone el formato precio a los datos editados en descuento
        }   
        else{
            label.textContent = 0;
        div.appendChild(label);
        return this.createElementJaivana(div);
        }
    }

    cantidadAgregadaChange(props){
        let seguir = this.getField('tablaAgregacion').cellValid(props.oldValue,props.newValue,'^[0-9]'); // Se valida que el dato ingresado sea un numero
        if (props.newValue < 0 ){
            props.data.cantidad_agregada = 0;
        }
        if(seguir){
            this.getField('cantidad_agregada').setValue(props.data.cantidad_agregada);
            let datos = {
                datos:{
                    id: props.data.id,
                    cantidad_agregada: this.getField('cantidad_agregada').getValue(), 
                    actividad_id:this.props.data.actividad_id
                }
            }

            this.generalFormatPmv = { tipo_servicio: 'prod-agregacionajustes', operacion: 'agregar', operacion_tipo: 'modificar' };
            this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method:'PUT',
                body: datos,
                success: this.successCantidadAgregada,
                error: this.error_,
                showMessage :false,
                general: this.generalFormatPmv
            });
            /*this.generalFormat.nombre_accion = '271-Permite_cambiar_agregado=1_del_registro'; 
            this.service.send(
                {
                    endpoint:this.constant.formConfiguration(),
                    method:'PUT',
                    body:body,
                    success:this.successCantidadAgregada,
                    error:this.error_,
                    general: this.generalFormat
                });*/
        }
    }

    successCantidadAgregada(response){
        if (response.estado_p === 200) {
            this.getField('cantidad_agregada').setValue(' ');
            this.uploadTbAgregacion();
        }
    }

    uploadTbAgregacion(){
        let datos = {
            datos:{
                value: this.props.data.id_ficha, 
            }
        }

        this.generalFormatPmv = { tipo_servicio: 'prod-agregacionajustes', operacion: 'fichaid', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successTbAgregacion,
            error: this.error_,
            showMessage :false,
            general: this.generalFormatPmv
        });

        /*
        this.generalFormat.nombre_accion = '271-Retorna_los_items_ajustes_leidos_por_produccion_fichas_id'; 
        this.service.send(
            {
                endpoint:this.constant.formConfiguration(),
                method:'GET',
                body:body,
                success:this.successTbAgregacion,
                error:this.error_,
                general: this.generalFormat
            });*/
    }

    grabarTodo(){
        this.getField('produccion_fichas_id').setValue(this.props.data.id_ficha);
        this.getField('proceso_id').setValue(this.props.data.proceso_id);
        this.getField('actividad_id').setValue(this.props.data.actividad_id);
        this.getField('actividad_configuracion_id').setValue(this.props.data.actividad_configuracion_id);
        this.getField('btnTerminarAgregacion').setDisabled(true);
        let datos = {
            datos:{
                id_formulario: this.formId,
                produccion_fichas_id:this.getField('produccion_fichas_id').getValue(),
                proceso_id:this.getField('proceso_id').getValue(),
                actividad_id:this.getField('actividad_id').getValue(),
                actividad_configuracion_id:this.getField('actividad_configuracion_id').getValue(),
            }
        }

        this.generalFormatPmv = { tipo_servicio: 'prod-agregacionajustes', operacion: 'terminar', operacion_tipo: 'crear' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'POST',
            body: datos,
            success: this.successCloseEstage,
            error: this.error_,
            showMessage :false,
            general: this.generalFormatPmv
        });
        /*this.generalFormat.nombre_accion = '271-Permite_terminar_la_actividad_de_agregacion'; 
        this.service.send(
            {
                endpoint:this.constant.formConfiguration(),
                method:'POST',
                body:body,
                success:this.successCloseEstage,
                error:this.error_,
                general: this.generalFormat
            });*/
    }
}

FormJaivana.addController("prod-agregacionajustes",CustomAjustesAgregacion);
export default CustomAjustesAgregacion;

